import { render, staticRenderFns } from "./LayoutDisplay.vue?vue&type=template&id=4a03854c&scoped=true&"
import script from "./LayoutDisplay.vue?vue&type=script&lang=js&"
export * from "./LayoutDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDisplay.vue?vue&type=style&index=0&id=4a03854c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a03854c",
  null
  
)

export default component.exports